import { customAuth } from "../standardAuthPatterns";
import { productVariant } from "../types";
import { escapeRegexLiteral } from "../urlPatternConversion";
import {
  OCI_SIGNING_KEY_SETUP,
  ociIdentityItems,
  ociPrivateKeyItem,
  ociSigningParams,
} from "./signingKey";

export const cloudVariant = productVariant({
  identifier: "oracleOciCloud",
  authLabel: "Cloud APIs (API signing key)",
  protocol: "http",
  defaultUrlPattern: ({ region }) =>
    region
      ? `https://[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*\\.${escapeRegexLiteral(region)}(?:\\.oci)?\\.oraclecloud\\.com/.*`
      : "",
  auth: (app) => customAuth("oci", ociSigningParams(app)),
  steps: [
    {
      title: "Create an OCI API signing key",
      items: [
        {
          kind: "markdown",
          content: `${OCI_SIGNING_KEY_SETUP} Grant only the permissions your workflows need, including permission to inspect the tenancy’s region subscriptions for the connection test. This mode covers standard OCI REST signing; Object Storage PUT and dedicated endpoints may have service-specific requirements.`,
        },
      ],
    },
    {
      title: "Enter your OCI credentials",
      items: [...ociIdentityItems, ociPrivateKeyItem],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ region, tenancyOcid }) =>
      `https://identity.${region}.oci.oraclecloud.com/20160918/tenancies/${encodeURIComponent(tenancyOcid)}/regionSubscriptions`,
  },
  usageHint: () =>
    "Make HTTPS calls to standard OCI REST APIs in the configured region. The proxy signs requests with the API signing key. Use the Generative AI mode for model inference. Object Storage PUT and dedicated endpoints may have service-specific requirements.",
});
